import { Injectable } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { ModalDialogComponent } from "@caseworthy/cw-ui-components";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";

  constructor(private _snackBar: MatSnackBar, public dialog: MatDialog) {}

  openSnackBar(message: string, duration: number, type: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: duration,
      panelClass: type == "success" ? ["success-snackbar"] : ["error-snackbar"],
    });
  }
  openDialog(componentName: any, inputData: any) {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: { component: componentName, inputData: inputData },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }
}
